import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import FilterPanel from "./includes/FilterPanel";
import "./CSS/ProfilesList.css";
import { calculateAge } from "./utils/utils";
import ProfileCard from "./includes/profileCard";
import HeroSection from "./includes/heroSection";

export default function ProfilesList({ url, title }) {
  const [profiles, setProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [visibleProfiles, setVisibleProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  // Centralized filter state
  const [filters, setFilters] = useState({
    genderFilter: "",
    idFilter: "",
    nameFilter: "",
    ageFilter: { minValue: 0, maxValue: 100 },
    jobFilter: "",
    nakshatramFilter: "",
    placeFilter: "",
    salaryFilter: "",
    // salaryFilter: {minSalaryValue: 0, maxSalaryValue:100},
  });

  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}${url}`, {credentials: "include"})
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setProfiles(data.data);
          setFilteredProfiles(data.data);
          setVisibleProfiles(data.data.slice(0, 12));
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching profiles:", err);
        setLoading(false);
      });
  }, [url]);

  // Apply filters whenever filter state changes
  useEffect(() => {
    let results = profiles;
    const {
      genderFilter,
      idFilter,
      nameFilter,
      ageFilter,
      jobFilter,
      nakshatramFilter,
      placeFilter,
      salaryFilter,
    } = filters;

    if (genderFilter)
      results = results.filter(
        (p) => p.gender && p.gender.toLowerCase() === genderFilter.toLowerCase()
      );

    if (idFilter)
      results = results.filter(
        (p) =>
          p.profile_id &&
          p.profile_id.toLowerCase().includes(idFilter.toLowerCase())
      );

    if (nameFilter)
      results = results.filter(
        (p) => p.name && p.name.toLowerCase().includes(nameFilter.toLowerCase())
      );

    if (nakshatramFilter)
      results = results.filter(
        (p) =>
          p.nakshatram &&
          p.nakshatram.toLowerCase() === nakshatramFilter.toLowerCase()
      );

    if (jobFilter)
      results = results.filter(
        (p) => p.jobType && p.jobType.toLowerCase() === jobFilter.toLowerCase()
      );

    if (placeFilter)
      results = results.filter(
        (p) =>
          p.workPlace &&
          p.workPlace.toLowerCase().includes(placeFilter.toLowerCase())
      );

    if (salaryFilter)
      results = results.filter(
        (p) => p.salary && parseFloat(p.salary) >= parseFloat(salaryFilter)
        // (p) => parseFloat(p.salary) >= parseFloat(salaryFilter.minSalaryValue) && parseFloat(p.salary) <= parseFloat(salaryFilter.maxSalaryValue)
      );

    if (ageFilter)
      results = results.filter(
        // (p) => p.age && parseInt(p.age) === parseInt(ageFilter)
        (p) =>
          calculateAge(p.dob) >= ageFilter.minValue &&
          calculateAge(p.dob) <= ageFilter.maxValue
      );

    setFilteredProfiles(results);
    setPage(1);
    setVisibleProfiles(results.slice(0, 12));
  }, [filters, profiles]);

  // Infinite scroll
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 50 >=
      document.documentElement.offsetHeight
    ) {
      loadMore();
    }
  };

  const loadMore = () => {
    const nextPage = page + 1;
    const start = (nextPage - 1) * 12;
    const end = nextPage * 12;
    const moreProfiles = filteredProfiles.slice(start, end);

    if (moreProfiles.length > 0) {
      setVisibleProfiles([...visibleProfiles, ...moreProfiles]);
      setPage(nextPage);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  });

  return (
    <><HeroSection /><div className="container mt-5">
      {/* <Link to={`${process.env.PUBLIC_URL}/matrimony`} className="btn btn-primary">
        Add Profile
      </Link> */}

      {/* Filter Side Panel */}
      <FilterPanel
        show={showFilters}
        onClose={() => setShowFilters(false)}
        filters={filters}
        setFilters={setFilters} />



      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="section-heading mb-0">{title}</h2>
        <div className="filter-bar">
          <button className="btn-filter" onClick={() => setShowFilters(true)}><i className="fas fa-sliders-h" />Filters</button>
          
        </div>
      </div>


      {/* Profiles */}
      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : visibleProfiles.length === 0 ? (
        <p className="text-center">No profiles found</p>
      ) : (
        <div className="row">
          {visibleProfiles.map((profile, index) => (
            <ProfileCard key={index} profile={profile} />
          ))}
        </div>
      )}
    </div></>
  );
}
